import CountyCareTemplate from "./CountyCareTemplate";
const templates = {
  CountyCareTemplate
};

export default templates;